import React from 'react';
import { connect } from 'react-redux';
import { Redirect, RouteComponentProps } from 'react-router-dom';

import { IRootState } from 'app/shared/reducers';
import { login, verify2FA, reset2FA } from 'app/shared/reducers/authentication';
import LoginModal from './login-modal';
import TwoFactorModal from './two-factor-modal';

export interface ILoginProps extends StateProps, DispatchProps, RouteComponentProps<{}> {}

export interface ILoginState {
  showModal: boolean;
  show2FA: boolean;
}

export class Login extends React.Component<ILoginProps, ILoginState> {
  private username = '';
  private rememberMe = false;

  state: ILoginState = {
    showModal: this.props.showModal,
    show2FA: this.props.show2FA
  };

  componentDidUpdate(prevProps: ILoginProps) {
    if (this.props !== prevProps) {
      this.setState({ showModal: this.props.showModal });
      this.setState({ show2FA: this.props.show2FA });
    }
  }

  handleLogin = (username, password, rememberMe = false) => {
    this.username = username;
    this.rememberMe = rememberMe;
    this.props.login(username, password, rememberMe);
  };

  handleVerify2FA = (code: string) => {
    this.props.verify2FA(this.username, code, this.rememberMe);
  };

  handleClose = () => {
    this.setState({ showModal: false });
    this.setState({ show2FA: false });
    this.props.reset2FA();
  };

  render() {
    const { location, isAuthenticated, requires2FA } = this.props;
    const { from } = location.state || { from: { pathname: '/', search: location.search } };
    const { showModal, show2FA } = this.state;

    if (isAuthenticated) {
      return <Redirect to={from} />;
    }

    if (show2FA && requires2FA) {
      return (
        <TwoFactorModal show2FA={show2FA} username={this.username} handleVerify={this.handleVerify2FA} handleClose={this.handleClose} />
      );
    }

    return (
      <LoginModal showModal={showModal} handleLogin={this.handleLogin} handleClose={this.handleClose} loginError={this.props.loginError} />
    );
  }
}

const mapStateToProps = ({ authentication }: IRootState) => ({
  isAuthenticated: authentication.isAuthenticated,
  loginError: authentication.loginError,
  showModal: authentication.showModalLogin,
  requires2FA: authentication.requires2FA,
  show2FA: authentication.requires2FA
});

const mapDispatchToProps = { login, verify2FA, reset2FA };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login);
